// import { DashboardExerciseProgress, DashboardExerciseProgressRequest, DashboardExerciseResponse, DashboardExerciseSummary, DashboardHomeResponse, DashboardTimeframedRequest, Exercise, ExerciseCreateRequest, ExerciseSearchRequest, HomeMuscleGroupRanking, MostTrainedExercise, User, Workout, WorkoutFrequency, WorkoutRequest } from '@api/entities';
import { Store } from '@reduxjs/toolkit';
import { ExerciseApiService, IExerciseApiService } from '../services/exercise/exercise.api.service';
import { DashboardApiService, IDashboardApiService } from '../services/dashboard/dashboard.api.service';
import { DashboardExerciseProgress, DashboardExerciseProgressRequest, DashboardExerciseResponse, DashboardExerciseSummary, DashboardHomeResponse, DashboardMostTrainedGroup, DashboardSessionExerciseSummaryRequest, DashboardSessionSummary, DashboardTimeframedRequest, DashboardWorkoutExerciseSummaryRequest, HomeMuscleGroupRanking, MostTrainedExercise, Workout, WorkoutFrequency, WorkoutRequest } from 'src/api/entities';

export interface IDashboardManager {
    getSessionSummary(sessionID: number): Promise<DashboardSessionSummary>;
    getWorkoutSummary(sessionID: number): Promise<DashboardSessionSummary>;
    getWorkoutHeadStatus(request: WorkoutRequest): Promise<Workout[]>;
    getMostTrainedExercise(request: DashboardTimeframedRequest): Promise<MostTrainedExercise[]>;
    getAllTrainedExercise(request: DashboardTimeframedRequest): Promise<MostTrainedExercise[]>;
    getMuscleGroupRanking(request: DashboardTimeframedRequest): Promise<HomeMuscleGroupRanking[]>;
    getWorkoutFrequency(request: DashboardTimeframedRequest): Promise<WorkoutFrequency>;
    getDashboardHome(request: DashboardTimeframedRequest): Promise<DashboardHomeResponse>;
    getDashboardExercise(request: DashboardExerciseProgressRequest): Promise<DashboardExerciseResponse>;
    getDashboardExerciseSummary(request: DashboardExerciseProgressRequest): Promise<DashboardExerciseSummary>;
    getDashboardExerciseProgress(request: DashboardExerciseProgressRequest): Promise<DashboardExerciseProgress[]>;
    getDashboardSessionExerciseSummary(request: DashboardSessionExerciseSummaryRequest): Promise<Array<DashboardExerciseSummary>> ;
    getDashboardWorkoutExerciseSummary(request: DashboardWorkoutExerciseSummaryRequest): Promise<Array<DashboardExerciseSummary>>;
}

export class DashboardManager implements IDashboardManager {
    private static instance: DashboardManager;
    private storeManager: Store;
    private dashboardService: IDashboardApiService;

    private constructor() {
        this.dashboardService = DashboardApiService.getInstance(process.env.REACT_APP_MICROSERVICE_AUTH_BASEPATH!);
    }

    static getInstance() {
        if (DashboardManager.instance == null) {
            DashboardManager.instance = new DashboardManager();
        }
        return DashboardManager.instance;
    }
    async getSessionSummary(sessionID: number): Promise<DashboardSessionSummary> {
      const response: DashboardSessionSummary = (
        await this.dashboardService.getSessionSummary(sessionID)
      );
      return response;
    }
    async getWorkoutSummary(sessionID: number): Promise<DashboardSessionSummary> {
      const response: DashboardSessionSummary = (
        await this.dashboardService.getWorkoutSummary(sessionID)
      );
      return response;
    }
    async getWorkoutHeadStatus(request: WorkoutRequest): Promise<Workout[]> {
      const response: Workout[] = (
        await this.dashboardService.getWorkoutHeadStatus(request)
      );
      return response;
    }
    async getMostTrainedExercise(request: DashboardTimeframedRequest): Promise<MostTrainedExercise[]> {
      const response: MostTrainedExercise[] = (
        await this.dashboardService.getMostTrainedExercise(request)
      );
      return response;
    }
    async getAllTrainedExercise(request: DashboardTimeframedRequest): Promise<MostTrainedExercise[]> {
      const response: MostTrainedExercise[] = (
        await this.dashboardService.getAllTrainedExercise(request)
      );
      return response;
    }
    async getAllTrainedGroups(request: DashboardTimeframedRequest): Promise<DashboardMostTrainedGroup[]> {
      const response: DashboardMostTrainedGroup[] = (
        await this.dashboardService.getAllTrainedGroups(request)
      );
      return response;
    }
    async getMuscleGroupRanking(request: DashboardTimeframedRequest): Promise<HomeMuscleGroupRanking[]> {
      const response: HomeMuscleGroupRanking[] = (
        await this.dashboardService.getMuscleGroupRanking(request)
      );
      return response;
    }
    async getWorkoutFrequency(request: DashboardTimeframedRequest): Promise<WorkoutFrequency> {
      const response: WorkoutFrequency = (
        await this.dashboardService.getWorkoutFrequency(request)
      );
      return response;
    }
    async getDashboardHome(request: DashboardTimeframedRequest): Promise<DashboardHomeResponse> {
      const response: DashboardHomeResponse = (
        await this.dashboardService.getDashboardHome(request)
      );
      return response;
    }
    async getDashboardExerciseSummary(request: DashboardTimeframedRequest): Promise<DashboardExerciseSummary> {
      const response: DashboardExerciseSummary = (
        await this.dashboardService.getDashboardExerciseSummary(request)
      );
      return response;
    }
    async getDashboardExerciseProgress(request: DashboardExerciseProgressRequest): Promise<DashboardExerciseProgress[]> {
      const response: DashboardExerciseProgress[] = (
        await this.dashboardService.getDashboardExerciseProgress(request)
      );
      return response;
    }
    async getDashboardExercise(request: DashboardExerciseProgressRequest): Promise<DashboardExerciseResponse> {
      const response: DashboardExerciseResponse = (
        await this.dashboardService.getDashboardExercise(request)
      );
      return response;
    }
    async getDashboardSessionExerciseSummary(request: DashboardSessionExerciseSummaryRequest): Promise<DashboardExerciseSummary[]> {
      const response: DashboardExerciseSummary[] = (
        await this.dashboardService.getDashboardSessionExerciseSummary(request)
      );
      return response;
    }
    async getDashboardWorkoutExerciseSummary(request: DashboardWorkoutExerciseSummaryRequest): Promise<DashboardExerciseSummary[]> {
      const response: DashboardExerciseSummary[] = (
        await this.dashboardService.getDashboardWorkoutExerciseSummary(request)
      );
      return response;
    }
}
